import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as ROUTES from '../../constants/routes';
import BlogList from './BlogList';
import BlogPost from './BlogPost';

export default function Blog() {
  const { t, i18n } = useTranslation();
  const forceLtr = i18n.language === 'ar';

  return (
    <div className="container" dir={forceLtr ? 'ltr' : undefined}>
      <h1 className="text-dark mb-4">{t('blog.pageTitle', 'Blog')}</h1>
      <Switch>
        <Route exact path={ROUTES.BLOG} component={BlogList} />
        <Route path={`${ROUTES.BLOG}/:id`} component={BlogPost} />
      </Switch>
    </div>
  );
} 